import * as React from 'react';
export const midfirstSvg = React.forwardRef(function midfirstSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F37920',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.023 26H26V6.023l-10.051 5.37L6 6l.034 19.989-.011.011Zm13.93-12.429-2.11-1.094 5.99-3.056v14.47h-3.88V13.57ZM7.928 9.41l5.99 3.056-2.122 1.095v10.32h-3.88V9.41h.012Zm6.001 5.188 1.963-1.014 1.962 1.014v9.293h-3.936v-9.293h.011Z',
      fill: '#FEFEFE',
    }),
  );
});
midfirstSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var midfirst = {
  category: 'brand',
  colorable: false,
  name: 'midfirst',
  svg: midfirstSvg,
};
